import { Box, Typography } from '@mui/material'
import { useState } from 'react'
import BookingDetails from './BookingDetails'
import CancellationPolicy from './CancellationPolicy'
import LastTransaction from './LastTransaction'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import BusRoute from './BusRoute'
const TripBookingDetails = (props) => {
    const { bkgDeatails } = props
    const [selectedTab, setSelectedTab] = useState(0)
    const [showAndHideTab, setShowAndHideTab] = useState(localStorage.getItem('showAndHideTab') === 'true' ? true : false)
    const tabList = [
        { name: 'Trip Details', id: 0 },
        { name: 'Last Transaction', id: 1 },
        { name: 'Cancellation Policy', id: 2 },
        { name: 'Vai Cities', id: 3 },



    ]
    return (
        <Box className='tripBookingDetails_page' sx={{ height: showAndHideTab ? '180px !important' : 'auto !important' }}>
            <Box sx={{
                flexShrink: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '6px',
                borderBottom: '1px solid #00000033'

            }}>
                <Box className='bkgTab' sx={{ flex: 1 }}>
                    {tabList.map((obj) => (
                        <Box className={`tabButton ${selectedTab === obj.id ? 'active' : ''}`} onClick={() => {
                            if (selectedTab === obj.id) {
                                setShowAndHideTab(!showAndHideTab)
                                localStorage.setItem('showAndHideTab', !showAndHideTab)
                            } else {
                                setShowAndHideTab(true)
                                localStorage.setItem('showAndHideTab', true)
                            }
                            setSelectedTab(obj.id)

                        }}>
                            <Typography>{obj.name}</Typography>
                        </Box>
                    ))}
                </Box>
                <Box sx={{ width: '30px', display: 'flex', justifyContent: 'center' }}>
                    {showAndHideTab ?

                        <KeyboardArrowDownIcon onClick={() => {
                            setShowAndHideTab(!showAndHideTab)
                            localStorage.setItem('showAndHideTab', !showAndHideTab)
                        }} />

                        :
                        <KeyboardArrowUpIcon onClick={() => {
                            setShowAndHideTab(!showAndHideTab)
                            localStorage.setItem('showAndHideTab', !showAndHideTab)
                        }} />

                    }
                </Box>

            </Box>
            {showAndHideTab && (
                <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto',  }} className='scrollBlueV8'>
                    {selectedTab === 0 &&
                        <BookingDetails tripDetails={bkgDeatails?.tripDetails || {}} />
                    }
                    {selectedTab === 1 &&
                        <LastTransaction />
                    }
                    {selectedTab === 2 &&
                        <CancellationPolicy cancelPolicyData={bkgDeatails?.cancelPolicyData || []} />
                    }
                    {selectedTab === 3 &&
                        <BusRoute bkgDeatails={bkgDeatails} />
                    }
                </Box>
            )}
        </Box>
    )
}

export default TripBookingDetails 